import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { TemplateEditorComponent } from './template-editor/template-editor.component';

/** Asks before leaving the editor with unsaved changes (Back, toolbar, sidebar, browser back). */
@Injectable({
    providedIn: 'root'
})
export class UnsavedChangesGuard implements CanDeactivate<TemplateEditorComponent> {
    canDeactivate(component: TemplateEditorComponent): boolean | Promise<boolean> {
        return component ? component.canDeactivate() : true;
    }
}
